<template>
  <div class="bg-white shadow-2l p-10 pt-5 md:rounded-b-lg hidden md:block">
    <h2 class="font-bold text-2xl pb-2 mb-2 text-gray-800">
      <i class="bx bx-cart text-indigo-500"></i>
      Resumo de carrinho
    </h2>
    <div class="description">
      <p
        class="text-gray-600 pb-2 text-sm"
      >{{ $store.state.description }}</p>
    </div>
    <div class="price rounded p-5 border-2 mt-5">
      <table class="w-full">
        <tbody>
          <tr>
            <td class="text-gray-700">Subtotal</td>
            <td class="text-right font-bold text-gray-800">{{ $store.state.price | toCurrency}}</td>
          </tr>
          <tr>
            <td class="text-gray-700">Entrega</td>
            <td
              class="text-right font-bold text-gray-800"
            >{{ $store.state.shipping_amount | toCurrency}}</td>
          </tr>
          <tr class>
            <td class="text-gray-700">Total</td>
            <td
              class="text-right font-bold text-2xl text-gray-800"
            >{{ $store.state.total_price | toCurrency}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cart-desktop'
}
</script>

<style>
</style>
